import { EmailLogs, prisma, ResourceType, ActionType } from "client";

// Create
export const createEmailLogs = async (data: EmailLogs) => {
  try {
    const emailLogs = await prisma.emailLogs.create({
      data: {
        data,
      },
    });
    return { emailLogs };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllEmailLogs = async (): // userId: string
Promise<{
  emailLogs?: EmailLogs[];
  error?: any;
}> => {
  try {
    const emailLogs = await prisma.emailLogs.findMany();
    return { emailLogs };
  } catch (error) {
    return { error };
  }
};

export const getEmailLogsById = async (
  // userId: string,
  id: string
) => {
  try {
    const emailLogs = await prisma.emailLogs.findUnique({
      where: { id },
    });
    return { emailLogs };
  } catch (error) {
    return { error };
  }
};

// DELETE

export const deleteEmailLogs = async (
  // userId: string,
  id: string
) => {
  try {
    const emailLogs = await prisma.emailLogs.delete({
      where: { id },
    });
    return { emailLogs };
  } catch (error) {
    return { error };
  }
};
